import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerInvestmentSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    mainFloorSpace: validationRules.mainFloorSpaceRequired,
    price: usePurchasePriceOnRequestCondition,
    buildingType: validationRules.buildingType,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  otherFacilities: {
    pricePerSQM: validationRules.pricePerSQM,
    priceMultiplier: validationRules.priceMultiplier,
    plotArea: validationRules.plotAreaOptional,
    totalFloorSpace: validationRules.totalFloorSpaceOptional,
    livingSpace: validationRules.livingSpaceInvestment,
    totalFloorsNumber: validationRules.totalFloorSpaceOptional,
    industrialArea: validationRules.industrialArea,
    additionalArea: validationRules.additionalArea,
    additionalCosts: validationRules.additionalCosts,
    serviceCharge: validationRules.serviceCharge,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
    rentalIncomeActual: validationRules.rentalIncomeActual,
    rentalIncomeTarget: validationRules.rentalIncomeTarget,
  },
  connections: defaultConnections,
  construction: defaultConstruction,
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
}
